import { ToolOutlined } from '@ant-design/icons';
import { selectedTagStyle } from '../styles/shared';
import { Tag, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface IProps {
  label: string;
  /** 'selected' is the primary tint used inside a select field, 'neutral' the grey chip in pickers. */
  variant?: 'selected' | 'neutral';
  closable?: boolean;
  onClose?: (e: React.MouseEvent<HTMLElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  style?: React.CSSProperties;
}

const neutralTagStyle: React.CSSProperties = {
  ...selectedTagStyle,
  background: '#f5f5f5',
  border: '1px solid #bfbfbf',
  color: '#333',
};

/**
 * Service chip for the pickers. Service labels ('<code> <category> - <name>') easily outgrow a
 * field, so the tag is capped at its container width and the label ellipsises with the full text
 * on hover. The icon is rendered as a plain child rather than through Tag's `icon` prop, because
 * that prop wraps the children in an extra span the label cannot shrink inside of.
 */
export const ServiceTag: React.FC<IProps> = ({
  label,
  variant = 'selected',
  closable = false,
  onClose,
  onClick,
  style,
}) => (
  <Tag
    closable={closable}
    onClose={onClose}
    onClick={onClick}
    style={{
      ...(variant === 'neutral' ? neutralTagStyle : selectedTagStyle),
      maxWidth: '100%',
      margin: 0,
      ...style,
    }}
  >
    <ToolOutlined style={{ flexShrink: 0 }} />
    <Text
      ellipsis={{ tooltip: label }}
      style={{ minWidth: 0, fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}
    >
      {label}
    </Text>
  </Tag>
);
